import { Component, Input, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AssetService } from 'src/app/services/asset.service';
import { UserDocumentService } from 'src/app/services/user-document.service';

@Component({
  selector: 'app-all-forms',
  templateUrl: './all-forms.component.html',
  styleUrls: ['./all-forms.component.scss']
})
export class AllFormsComponent implements OnInit {

  userId
  assetId
  loading
  inspectionFormData = []
  selectedIndex: number = 0
  selectedFormDetails
  // userDetails
  @Input('asset') assetData
  @Input('user') userData
  @Input('userDetails') userDetails
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter<any>();
  previousIndex: any;
  assetDetails = []
  assetUserList = []
  constructor(
    public activatedRouter: ActivatedRoute,
    public route: Router,
    public _assetService: AssetService,
    public _userDocumentService: UserDocumentService
  ) { }

  ngOnInit() {



    this.activatedRouter.params.subscribe(params => {
      // this.dataSource = new MatTableDataSource(this.userList);
      this.assetId = params.id;
      console.log('check params data..', params, this.assetId)
      // this.getSingleAseetDetails()
    })
    this.activatedRouter.queryParams.subscribe(params => {
      // this.dataSource = new MatTableDataSource(this.userList);
      this.userId = params.user;
      console.log('check params data..', params)
      this.getInspectionFormData()
    })
  }




  checkType(item) {

    let url = this.route.url.split('/')
    // console.log("this.route.url",url[2])

    // console.log("current url ot route", url);
    if (url[2] == item) {
      return true
    } else {
      return false
    }


  }

  fileDetails(event) {
    console.log("hey this event emit call ")
    console.log("event ====", event.event.file);
    this.previousIndex = event.event.index
    this._assetService.displayFile(event)
    // this.openFilesSideNav.emit({ event })
  }

  getInspectionFormData() {
    let obj = {
      assetId: this.assetId,
      userId: this.userId
    }
    this.loading = true
    console.log('value of obj..', obj)
    this._assetService.getInspectionFormData(obj).subscribe((response) => {
      this.assetDetails = response.assetData
      this.assetUserList = response.userList
      console.log("response of all-forms ", response, this.assetDetails);
      if (response.data && response.data.length) {
        this.loading = false
        this.userDetails = response.data
        // this.inspectionFormData = response
        // this.selectedIndex = this.inspectionFormData[0]._id
        // this.selectedFormDetails = this.inspectionFormData[0].userDocumentId
        // this.changeFormData()
      } else {
        console.log("no data");
        this.loading = false
      }
    }, err => {
      console.log("err", err);
      this.loading = false
    })
  }


}
